import { useEffect } from 'react';
import { Link, useRouteError } from 'react-router';
import { Box, Button, Stack, Typography } from '@mui/material';

import Logger from 'browser-logging/src/browser/Logger';

import ImageLoader from 'portal/src/components/common/ImageLoader';
import {
  DEFAULT_ERROR_BODY_TEXT,
  DEFAULT_ERROR_HEADER_TEXT,
} from 'portal/src/constants/errorText';

const errorImg = import.meta.env.VITE_ERROR_IMG || '/404_Error_Page_src.png';

export default function Error() {
  const error: any = useRouteError();

  useEffect(() => {
    Logger.captureError(error);
  }, [error]);

  return (
    <Stack
      sx={{ alignItems: 'center', justifyContent: 'center', height: '100vh' }}
    >
      <ImageLoader
        src={errorImg}
        alt="Error"
        effect="opacity"
        effectDuration={600}
        height="30rem"
        wrapperStyle={{ transitionDelay: '1s' }}
        style={{
          width: 'auto',
          zIndex: -1,
        }}
      />

      <Typography variant="h3">
        {error?.status ?? DEFAULT_ERROR_HEADER_TEXT}
      </Typography>
      <Typography variant="body1">
        {error?.statusText ?? DEFAULT_ERROR_BODY_TEXT}
      </Typography>
      <Button
        component={Link}
        to="/"
        variant="contained"
        color="secondary"
        sx={{ mt: 2 }}
      >
        Back to Home Page
      </Button>
      <Box sx={{ position: 'absolute', bottom: 0, right: 0 }}>
        <Typography variant="caption" align="center">
          <Link
            to="https://www.freepik.com/free-vector/page-found-with-people-connecting-plug-concept-illustration_7938315.htm#query=something%20went%20wrong&position=24&from_view=search&track=ais"
            target="_blank"
            rel="noopener noreferrer"
          >
            Image by storyset
          </Link>{' '}
          on Freepik
        </Typography>
      </Box>
    </Stack>
  );
}
